import { render, staticRenderFns } from "./FilterBasic.vue?vue&type=template&id=2a8eb5b0&"
import script from "./FilterBasic.vue?vue&type=script&lang=js&"
export * from "./FilterBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a8eb5b0')) {
      api.createRecord('2a8eb5b0', component.options)
    } else {
      api.reload('2a8eb5b0', component.options)
    }
    module.hot.accept("./FilterBasic.vue?vue&type=template&id=2a8eb5b0&", function () {
      api.rerender('2a8eb5b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/criterion/FilterBasic.vue"
export default component.exports